import { IconProps } from '../types';
import { ORDER_METHODS } from '../../../services/exports/Constants';
import PickupIcon from './PickupIcon';
import DeliveryIcon from './DeliveryIcon';
import RoomServiceIcon from './RoomServiceIcon';

interface Props extends IconProps {
  orderMethod: ORDER_METHODS;
}

export default function OrderMethodIcon({ orderMethod, ...rest }: Props) {
  return (
    {
      [ORDER_METHODS.PICKUP]: <PickupIcon {...rest} />,
      [ORDER_METHODS.DELIVERY]: <DeliveryIcon {...rest} />,
      [ORDER_METHODS.ROOM_SERVICE]: <RoomServiceIcon {...rest} />,
    }[orderMethod] ?? null
  );
}
